import RichTextWithImageBlock from './RichTextWithImageBlock';

export default RichTextWithImageBlock;
